import { ReactNode } from "react";
import * as ReactDOM from "react-dom";
import "./Dialog.scss";

interface DialogProps {
    id?: string;
    className?: string;
    width?: 'standard' | 'small' | 'tiny';
    title?: string;
    onClose?: () => void;
    children: ReactNode;
}

const Dialog = (props: DialogProps) => {
    const dialogMarkup = <>
        <div className="dialog-background">
        </div>
        <div id={props.id} className={`dialog dialog-color-white'} dialog-width-${props.width ?? 'standard'} ${props.className}`}>
            {props.title && <h1>{props.title}</h1>}
            {props.onClose && <button className="dialog-close-button" onClick={props.onClose}>&#10006;</button>}
            {props.children}
        </div>
    </>

    return ReactDOM.createPortal(
        dialogMarkup,
        document.body
    );
}

export default Dialog;